import { Routes, Route, Navigate } from "react-router-dom";
import DocumentationLayout from "./documentation/DocumentationLayout";
import DocumentationSectionPage from "./documentation/DocumentationSectionPage";

export default function DocumentationPage() {
    return (
        <Routes>
            <Route element={<DocumentationLayout />}>
                <Route index element={<Navigate to="getting-started" replace relative="path" />} />
                <Route path=":sectionId" element={<DocumentationSectionPage />} />
            </Route>
        </Routes>
    );
}
